/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookOpenIcon16Solid = forwardRef('BookOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.25 2.918c-1.672-1.035-3.963-.982-5.256-.843C1.41 2.138 1 2.643 1 3.23v8.402c0 .757.67 1.352 1.428 1.35 1.37-.004 3.43.195 4.822 1.261V2.918Z" }),
        React.createElement("path", { d: "M8.75 14.244c1.393-1.066 3.453-1.264 4.822-1.26.758.001 1.428-.594 1.428-1.351V3.23c0-.588-.41-1.093-.994-1.156-1.293-.14-3.584-.192-5.256.843v11.326Z" })));
});
